<template>
    <div id="authentication">
        <router-view />
    </div>
</template>
<script>
export default {
  mounted(){
      if (this.$store.getters['auth/isLogin']) {
          router.push({ name: 'Dashboard' })
      }
  }
};
</script>